import { javascriptLanguage } from '@codemirror/lang-javascript';

export const getAuthAutocomplete = () => {
  return javascriptLanguage.data.of({
    autocomplete: (context: {
      matchBefore: (regex: RegExp) => { from: number; to: number } | null;
      explicit: boolean;
    }) => {
      const word = context.matchBefore(/\w*/);
      if (!word || (word.from === word.to && !context.explicit)) return null;

      return {
        from: word.from,
        options: [
          {
            label: 'auth',
            type: 'method',
            detail: 'auth.getToken(settingsUid)',
            info: 'async method, get auth tokens by setting UId',
            apply: 'await auth.getToken(settingsUid)',
          },
          {
            label: 'auth',
            type: 'method',
            detail: 'auth.getToken(settingsUid, dynamicClaims)',
            info: 'async method, get an external token by uid with dynamic Claims (JWT). Parameter dynamicClaims should look like { claim1: "value1", claim2: "value2" }',
            apply: 'await auth.getToken(settingsUid, dynamicClaims)',
          },
        ],
      };
    },
  });
};
